import api from './axios';

export const fetchNotifications = (params) =>
  api.get('/notifications', { params }).then((r) => r.data);

export const fetchUnreadCount = () =>
  api.get('/notifications/unread-count').then((r) => r.data);

export const markNotificationRead = (id) =>
  api.put(`/notifications/${id}/read`).then((r) => r.data);

export const markAllNotificationsRead = () =>
  api.put('/notifications/read-all').then((r) => r.data);
